"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Tag, Loader, CircleAlert } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error,
    hasNext,
    loadMore,
    isRefetching
  } = usePosts();
  if (loading && posts.length === 0) {
    return <div data-section-id="161936" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden border-none bg-muted/50 animate-pulse">
            <AspectRatio ratio={16 / 9} className="bg-muted/30" />
            <div className="p-6 space-y-3">
              <div className="h-3 w-1/3 bg-muted/40 rounded" />
              <div className="h-6 w-full bg-muted/40 rounded" />
              <div className="h-6 w-4/5 bg-muted/40 rounded" />
            </div>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <CircleAlert className="size-12 text-destructive mb-4 opacity-80" />
        <p className="text-muted-foreground mb-4 font-sans">Παρουσιάστηκε σφάλμα κατά τη φόρτωση των άρθρων.</p>
        <Button variant="outline" onClick={() => window.location.reload()} className="font-sans">
          Δοκιμάστε ξανά
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground font-sans">Δεν βρέθηκαν άρθρα ή ενημερώσεις.</p>
      </div>;
  }
  return <div className="space-y-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post, i) => <Card key={post.id} data-index={i} className="group relative overflow-hidden border border-border rounded-lg bg-card transition-all duration-300 shadow-sm hover:shadow-lg">
            <Link to={post.link || "#"} className="block w-full h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
              <AspectRatio ratio={16 / 9} className="overflow-hidden bg-muted">
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628303/img/radio_signal_post_placeholder.png"} alt={post.title} className="w-full h-full object-cover grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" />
              </AspectRatio>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent flex flex-col justify-end p-6 transition-opacity duration-300">
                <div className="flex flex-wrap items-center gap-3 font-sans text-xs text-primary-foreground mb-3 opacity-90">
                  {post.date && <span className="flex items-center">
                      <SafeHydrate><Calendar className="size-3.5 mr-1.5 text-primary-foreground" /></SafeHydrate>
                      {new Date(post.date).toLocaleDateString('el-GR', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
                    </span>}
                  {post.categories && post.categories.length > 0 && <span className="flex items-center text-primary-foreground">
                      <Tag className="size-3.5 mr-1.5" />
                      {post.categories[0].name}
                    </span>}
                </div>
                
                <h3 className="text-xl md:text-2xl font-default font-bold text-white leading-tight line-clamp-2 group-hover:text-primary-foreground transition-colors duration-300" dangerouslySetInnerHTML={{
              __html: post.title
            }} />
              </div>
            </Link>
          </Card>)}
      </div>

      {hasNext && <div className="flex justify-center pt-8">
          <Button onClick={async () => await loadMore()} disabled={isRefetching} size="lg" className="font-sans font-medium uppercase tracking-wide bg-primary text-primary-foreground hover:bg-primary/90">
            {isRefetching ? <>
                <Loader className="mr-2 size-4 animate-spin" />
                Φορτωση...
              </> : "Περισσοτερα Αρθρα"}
          </Button>
        </div>}
    </div>;
}
export default function LatestNewsInterviews() {
  const wp_query_params = {
    per_page: 6,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}